import { useState, useEffect } from "react";

/**
 * Hook para detectar si la página ha sido scrolleada más allá del umbral (por defecto 80px)
 * - El estado solo cambia al cruzar el umbral para evitar re-renders innecesarios
 * - Listener de scroll pasivo { passive: true } con throttling vía requestAnimationFrame
 * - Limpieza adecuada al desmontar
 */
export default function useStickyNav(threshold = 80) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    let ticking = false;
    let rafId = null;

    const checkScroll = () => {
      const scrollY =
        window.pageYOffset || document.documentElement.scrollTop || 0;
      const scrolled = scrollY > threshold;
      setIsScrolled((prev) => (prev !== scrolled ? scrolled : prev));
      ticking = false;
    };

    const handleScroll = () => {
      if (!ticking) {
        rafId = window.requestAnimationFrame(checkScroll);
        ticking = true;
      }
    };

    // Verificación inicial diferida mediante requestAnimationFrame
    rafId = window.requestAnimationFrame(checkScroll);

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      if (rafId !== null) {
        window.cancelAnimationFrame(rafId);
      }
      window.removeEventListener("scroll", handleScroll);
    };
  }, [threshold]);

  return isScrolled;
}
